import { makeStyles, mergeClasses } from "@fluentui/react-components";
import { LuggageFilled } from "@fluentui/react-icons";
import React from "react";
import { BaggageData } from "../../models/flights/IFlightsCommon";
import {
  formatDisplayValue,
  formatHeaderDisplayValue,
} from "../../utils/common/FormatHelper";
import CardHeader from "./CardHeader";
import { useCardStyles } from "./shared.styles";

interface BaggageCardProps {
  data: BaggageData;
  className?: string;
}

const BaggageCard: React.FC<BaggageCardProps> = ({ data, className }) => {
  const shared = useCardStyles();
  const local = useLocalStyles();

  return (
    <article className={mergeClasses(shared.container, className)}>
      <CardHeader
        icon={<LuggageFilled />}
        title="Baggage"
        primaryValue={formatHeaderDisplayValue(data.totalBaggage)}
      />

      <section className={shared.content}>
        <dl className={shared.column}>
          <div className={shared.row}>
            <dt className={`${shared.label} ${local.label}`}>Accepted</dt>
            <dd className={`${shared.value} ${local.value}`}>
              {formatDisplayValue(data.accepted)}
            </dd>
          </div>
          <div className={shared.row}>
            <dt className={`${shared.label} ${local.label}`}>Loaded</dt>
            <dd className={`${shared.value} ${local.value}`}>
              {formatDisplayValue(data.loaded)}
            </dd>
          </div>
        </dl>
      </section>
    </article>
  );
};

export default BaggageCard;

const useLocalStyles = makeStyles({
  label: {
    width: "70px",
  },
  value: {
    width: "35px",
  },
});
